(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayo-about-editorial"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=(root)=>{if(root.dataset.ready)return;root.dataset.ready='1';const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const items=root.querySelectorAll('.ayo-about-v2__reveal');if(reduced||!('IntersectionObserver'in window)){items.forEach(x=>x.classList.add('is-visible'))}else{const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -6%'});items.forEach(x=>io.observe(x))}const quotes=[...root.querySelectorAll('[data-ayo-quote]')];const count=root.querySelector('[data-ayo-count]');let index=0;const show=(next)=>{if(!quotes.length)return;quotes[index].classList.remove('is-active');index=(next+quotes.length)%quotes.length;quotes[index].classList.add('is-active');if(count)count.textContent=`${String(index+1).padStart(2,'0')} / ${String(quotes.length).padStart(2,'0')}`};root.querySelector('[data-ayo-prev]')?.addEventListener('click',()=>show(index-1));root.querySelector('[data-ayo-next]')?.addEventListener('click',()=>show(index+1));show(0);if(!reduced){const names=root.querySelectorAll('.ayo-about-v2__name');window.addEventListener('scroll',()=>{const opening=root.querySelector('[data-ayo-opening]');const rect=opening.getBoundingClientRect();if(rect.bottom>0&&rect.top<innerHeight){const p=Math.max(0,Math.min(1,-rect.top/rect.height));names.forEach((name,i)=>{const direction=i%2?1:-1;name.style.transform=`translate3d(${direction*p*26}px,${p*(18+i*3)}px,0)`})}},{passive:true})}};document.querySelectorAll('[data-ayo-about-v2]').forEach(init);document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-ayo-about-v2]');if(root)init(root)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-ai-home-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('ayo-motion');
    const reveal = (scope = document) => {
      const elements = scope.querySelectorAll('.ayo-reveal:not([data-ayo-reveal])');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ayo-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      elements.forEach((element, index) => {
        element.dataset.ayoReveal = 'true';
        element.style.transitionDelay = `${Math.min(index % 3, 2) * 90}ms`;
        observer.observe(element);
      });
    };
    reveal();
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-ai-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    const init = (root) => {
      if (!root || instances.has(root)) return;
      const track = root.querySelector('.ayo-yuga__track');
      const cards = [...track.children];
      const title = root.querySelector('.ayo-yuga__marquee>div');
      const media = window.matchMedia('(min-width:801px) and (prefers-reduced-motion:no-preference)');
      const clamp = (value) => Math.min(1, Math.max(0, value));
      const ease = (value) => value < .5 ? 2 * value * value : 1 - Math.pow(-2 * value + 2, 2) / 2;
      let active = false, travel = 0, distance = 0, frame = 0;
      const render = () => {
        frame = 0;
        if (!active) return;
        const progress = clamp(-root.getBoundingClientRect().top / distance);
        const slide = ease(clamp((progress - .23) / .64));
        track.style.transform = `translate3d(${-travel * slide}px,0,0)`;
        title.style.transform = `translate3d(${-window.innerWidth * .45 * slide}px,0,0)`;
        cards.forEach((card, index) => {
          const enter = clamp((progress + .04 - index * .035) / .25);
          card.style.transform = `translate3d(0,${Math.pow(1 - enter, 4) * 105}%,0)`;
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(render); };
      const measure = () => {
        active = media.matches && !window.Shopify?.designMode;
        root.classList.toggle('is-scroll-driven', active);
        if (!active) {
          root.style.removeProperty('--scroll-height');
          track.style.transform = '';
          title.style.transform = '';
          cards.forEach(card => card.style.transform = '');
          return;
        }
        const last = cards[cards.length - 1];
        travel = Math.max(0, last.offsetLeft + last.offsetWidth + 24 - root.clientWidth);
        distance = Math.max(window.innerHeight * 1.65, travel * 2);
        root.style.setProperty('--scroll-height', `${window.innerHeight + distance}px`);
        render();
      };
      const focus = (event) => {
        if (!active) return;
        const card = event.target.closest('.ayo-yuga__card');
        if (!card) return;
        const index = cards.indexOf(card);
        const top = root.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({top:top + distance * (index ? .87 : .23),behavior:'instant'});
      };
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', measure);
      media.addEventListener('change', measure);
      root.addEventListener('focusin', focus);
      measure();
      instances.set(root, () => {
        cancelAnimationFrame(frame);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', measure);
        media.removeEventListener('change', measure);
        root.removeEventListener('focusin', focus);
      });
    };
    document.querySelectorAll('.ayo-yuga[data-section-id]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.ayo-yuga[data-section-id]')));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('.ayo-yuga');
      instances.get(root)?.();
      instances.delete(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-chatgpt-landing"] && !Shopify.designMode) return;
  try {
    
  function mountAyoReadiness(root) {
    if (root.dataset.ayoReadinessMounted === 'true') return;
    root.dataset.ayoReadinessMounted = 'true';

    const checks = Array.from(root.querySelectorAll('[data-ayo-readiness-check]'));
    const page = root.closest('[data-ayo-chatgpt-landing]');
    const score = root.querySelector('[data-ayo-readiness-score]');
    const meter = root.querySelector('[data-ayo-readiness-meter]');
    const title = root.querySelector('[data-ayo-readiness-title]');
    const copy = root.querySelector('[data-ayo-readiness-copy]');
    const formField = page ? page.querySelector('[data-ayo-readiness-field]') : null;

    function updateResult() {
      const selected = checks.filter((check) => check.checked);
      const total = checks.length;
      const count = selected.length;
      const percentage = total ? Math.round((count / total) * 100) : 0;
      let resultTitle = 'ZAZNACZ TO, CO JUŻ MASZ.';
      let resultCopy = 'Wynik pokaże, czy warto planować test teraz, czy najpierw poprawić fundamenty.';

      if (count > 0 && count <= 2) {
        resultTitle = 'NAJPIERW FUNDAMENTY.';
        resultCopy = 'ChatGPT Ads nie powinien wyprzedzać oferty, pomiaru i strony. Najpierw naprawmy elementy, które ograniczyłyby wynik testu.';
      } else if (count >= 3 && count < total) {
        resultTitle = 'JEST POTENCJAŁ DO TESTU.';
        resultCopy = 'Większość podstaw jest gotowa. W krótkiej diagnozie ustalimy, czego brakuje i czy kontrolowany pilot ma biznesowy sens.';
      } else if (total > 0 && count === total) {
        resultTitle = 'DOBRY MOMENT NA PILOT.';
        resultCopy = 'Masz podstawy do zaprojektowania mierzalnego testu. Następny krok to kontekst, kreacja, budżet i kryteria decyzji.';
      }

      score.textContent = `${count} / ${total}`;
      meter.style.width = `${percentage}%`;
      title.textContent = resultTitle;
      copy.textContent = resultCopy;

      if (formField) {
        const selectedLabels = selected.map((check) => check.value).join('; ');
        formField.value = `${count}/${total} — ${resultTitle}${selectedLabels ? ` Wybrane: ${selectedLabels}` : ''}`;
      }
    }

    checks.forEach((check) => check.addEventListener('change', updateResult));
    updateResult();
  }

  document.querySelectorAll('[data-ayo-readiness]').forEach(mountAyoReadiness);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ayo-readiness]').forEach(mountAyoReadiness);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-contact-editorial"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='1';const items=root.querySelectorAll('.ayo-contact-v2__reveal');if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window)){items.forEach(item=>item.classList.add('is-visible'));return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.12});items.forEach(item=>observer.observe(item))};document.querySelectorAll('[data-ayo-contact-v2]').forEach(init);document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-ayo-contact-v2]');if(root)init(root)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activate = (root, id) => {
      const update = () => {
        const activeTab = root.querySelector(`[data-ayo-tab="${id}"]`);
        if (activeTab && activeTab.dataset.ayoAccent) root.style.setProperty('--ayo-accent', activeTab.dataset.ayoAccent);
        root.querySelectorAll('[data-ayo-tab]').forEach((tab) => {
          const selected = tab.dataset.ayoTab === id;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          const mark = tab.querySelector('.ayo-service-picker__mark');
          if (mark) mark.textContent = selected ? '(—)' : '(+)';
        });
        root.querySelectorAll('[data-ayo-panel]').forEach((panel) => {
          const selected = panel.dataset.ayoPanel === id;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
      };
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update); else update();
    };
    const init = (root) => {
      if (!root || root.dataset.ayoReady === 'true') return;
      root.dataset.ayoReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-ayo-tab]'));
      tabs.forEach((tab) => tab.addEventListener('click', () => activate(root, tab.dataset.ayoTab)));
      root.addEventListener('keydown', (event) => {
        const current = event.target.closest('[data-ayo-tab]');
        if (!current || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const index = tabs.indexOf(current);
        const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        next.focus();
        activate(root, next.dataset.ayoTab);
      });
      root.addEventListener('shopify:block:select', (event) => {
        const selectedTab = event.target.closest('[data-ayo-tab]');
        if (selectedTab) activate(root, selectedTab.dataset.ayoTab);
      });
    };
    document.querySelectorAll('[data-ayo-service-hero]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ayo-service-hero]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-market-entry-hero"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='1';if(matchMedia('(prefers-reduced-motion: reduce)').matches||!matchMedia('(pointer:fine)').matches)return;root.addEventListener('pointermove',event=>{const rect=root.getBoundingClientRect();root.style.setProperty('--pointer-x',(((event.clientX-rect.left)/rect.width)-.5).toFixed(3));root.style.setProperty('--pointer-y',(((event.clientY-rect.top)/rect.height)-.5).toFixed(3))},{passive:true});root.addEventListener('pointerleave',()=>{root.style.setProperty('--pointer-x',0);root.style.setProperty('--pointer-y',0)})};document.querySelectorAll('[data-ayo-market-hero]').forEach(init);document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-ayo-market-hero]');if(root)init(root)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-neon-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const startVideo = video => {
      if (!video || video.dataset.ayoAutoplayReady) return;
      video.dataset.ayoAutoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const play = () => {
        if (!video.paused) return;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      };

      ['loadedmetadata', 'loadeddata', 'canplay'].forEach(eventName => {
        video.addEventListener(eventName, play, { once: true });
      });
      requestAnimationFrame(play);
      window.setTimeout(play, 250);
      window.setTimeout(play, 1000);
      window.addEventListener('pageshow', play);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) play();
      });
      document.addEventListener('touchstart', play, { once: true, passive: true });
      document.addEventListener('pointerdown', play, { once: true, passive: true });
    };

    const init = root => startVideo(root.querySelector('.ayo-new-hero__video'));
    document.querySelectorAll('.ayo-new-hero').forEach(init);
    document.addEventListener('shopify:section:load', event => {
      const root = event.target.querySelector('.ayo-new-hero');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-numbers-carousel"] && !Shopify.designMode) return;
  try {
    
function ayoInitNumbers(section){
  if(section.dataset.ayoNumbersReady)return;
  section.dataset.ayoNumbersReady='true';
  const viewport=section.querySelector('[data-ayo-numbers-viewport]');
  const cards=[...section.querySelectorAll('.ayo-numbers__card')];
  const prev=section.querySelector('[data-ayo-numbers-prev]');
  const next=section.querySelector('[data-ayo-numbers-next]');
  const progress=section.querySelector('[data-ayo-numbers-progress]');
  const line=section.querySelector('[data-ayo-numbers-progress-line]');
  if(!viewport||!cards.length)return;
  const current=()=>{
    const x=viewport.scrollLeft;
    let closest=0;
    let distance=Infinity;
    cards.forEach((card,index)=>{
      const d=Math.abs(card.offsetLeft-cards[0].offsetLeft-x);
      if(d<distance){distance=d;closest=index}
    });
    return closest;
  };
  let frame;
  const update=()=>{
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>{
      const index=current();
      prev.disabled=index===0;
      next.disabled=viewport.scrollLeft>=viewport.scrollWidth-viewport.clientWidth-2;
      const maxScroll=Math.max(1,viewport.scrollWidth-viewport.clientWidth);
      const ratio=Math.min(1,Math.max(0,viewport.scrollLeft/maxScroll));
      progress.setAttribute('aria-valuenow',String(Math.round(1+ratio*(cards.length-1))));
      line.style.width=`${20+ratio*80}%`;
    });
  };
  const move=direction=>{
    const index=Math.max(0,Math.min(cards.length-1,current()+direction));
    const left=cards[index].offsetLeft-cards[0].offsetLeft;
    viewport.scrollTo({left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  };
  prev.addEventListener('click',()=>move(-1));
  next.addEventListener('click',()=>move(1));
  viewport.addEventListener('scroll',update,{passive:true});
  viewport.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'){event.preventDefault();move(1)}
    if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}
  });
  window.addEventListener('resize',update,{passive:true});
  update();
}
document.querySelectorAll('[data-ayo-numbers]').forEach(ayoInitNumbers);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ayo-numbers]').forEach(ayoInitNumbers));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-process-stack"] && !Shopify.designMode) return;
  try {
    
function ayoSetupPstack(section){
  if(section.dataset.ayoProcessReady)return;
  section.dataset.ayoProcessReady='true';
  const cards=[...section.querySelectorAll('[data-ayo-pstack-card]')];
  const activate=index=>cards.forEach((card,i)=>{
    const active=i===index;
    card.classList.toggle('is-active',active);
    card.setAttribute('aria-expanded',String(active));
  });
  cards.forEach((card,i)=>{
    card.addEventListener('click',()=>activate(i));
    card.addEventListener('keydown',event=>{
      if(event.key==='Enter'||event.key===' '){event.preventDefault();activate(i)}
    });
  });
}
document.querySelectorAll('[data-ayo-pstack]').forEach(ayoSetupPstack);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ayo-pstack]').forEach(ayoSetupPstack));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-service-editorial"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='1';const items=root.querySelectorAll('.ayo-service-v2__reveal');if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window)){items.forEach(item=>item.classList.add('is-visible'));return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -5%'});items.forEach(item=>observer.observe(item))};document.querySelectorAll('[data-ayo-service-v2]').forEach(init);document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-ayo-service-v2]');if(root)init(root)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayo-service-page"] && !Shopify.designMode) return;
  try {
    
  function mountAyoNeonRoute(root) {
    if (root.dataset.ayoNeonMounted === 'true') return;
    root.dataset.ayoNeonMounted = 'true';

    const fills = Array.from(root.querySelectorAll('[data-ayo-neon-fill]'));
    const frames = Array.from(root.querySelectorAll('.ayo-sp-intro,.ayo-sp-scope,.ayo-sp-process,.ayo-sp-visual,.ayo-sp-faq,.ayo-sp-contact'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scheduled = false;

    function drawRoute() {
      scheduled = false;
      const rect = root.getBoundingClientRect();
      const distance = -rect.top + window.innerHeight * 0.08;
      const range = Math.max(root.offsetHeight - window.innerHeight * 0.15, 1);
      const progress = reducedMotion.matches ? 1 : Math.min(Math.max(distance / range, 0), 1);

      fills.forEach((path) => {
        path.style.strokeDashoffset = String(1 - progress);
      });

      frames.forEach((frame) => {
        const active = reducedMotion.matches || frame.getBoundingClientRect().top <= window.innerHeight * 0.72;
        frame.classList.toggle('is-neon-active', active);
      });
    }

    function requestDraw() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(drawRoute);
    }

    window.addEventListener('scroll', requestDraw, { passive: true });
    window.addEventListener('resize', requestDraw, { passive: true });
    reducedMotion.addEventListener('change', requestDraw);
    drawRoute();
  }

  document.querySelectorAll('.ayo-sp--neon-spine').forEach(mountAyoNeonRoute);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.ayo-sp--neon-spine').forEach(mountAyoNeonRoute);
  });

  } catch(e) { console.error(e); }
})();
})();
